// Shared list of artists so both the public Artists section and the admin post
// composer can pull from the same source of truth.
export const ARTISTS = [
  { id: "jay", name: "Jay", role: "Founder" },
  { id: "andres", name: "Andres", role: "Resident" },
  { id: "doy", name: "Doy", role: "Resident" },
  { id: "junwon", name: "Junwon", role: "Resident" },
  { id: "derrick", name: "Derrick", role: "Resident" },
  { id: "hando", name: "Hando", role: "Resident" },
  { id: "hong", name: "Hong", role: "Resident" },
  { id: "tae", name: "Tae", role: "Resident" },
  { id: "jinnie", name: "Jinnie", role: "Resident" },
  { id: "ari", name: "Ari", role: "Apprentice" },
  { id: "reagan", name: "Reagan", role: "Resident" },
  { id: "jorge", name: "Jorge", role: "Resident", adminOnly: true },
  { id: "miriam", name: "Miriam", role: "Management" },
  { id: "alex", name: "Alex", role: "Management" },
];

export const artistName = (idOrName) => {
  const found = ARTISTS.find((a) => a.id === idOrName || a.name === idOrName);
  return found ? found.name : idOrName || "Studio";
};
